import { render, staticRenderFns } from "./SettingList.vue?vue&type=template&id=4d3a63d2&scoped=true&"
import script from "./SettingList.vue?vue&type=script&lang=js&"
export * from "./SettingList.vue?vue&type=script&lang=js&"
import style0 from "./SettingList.vue?vue&type=style&index=0&id=4d3a63d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3a63d2",
  null
  
)

export default component.exports